var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cgw-title-bar [title]=\"'EHS.UNSAFE_CONDITION.TITLE' | translate\" url=\"\u002Fehs\"\u003E\u003C\u002Fgw-title-bar\u003E\u003Crouter-outlet\u003E\u003C\u002Frouter-outlet\u003E";;return pug_html;};
module.exports = template;